const AB_TESTS = [
];

const FEATURE_FLAGS = [
  {
    name: 'island_web_share_IS-2817',
    variations: ['control', 'on'],
    isEligible: () => true,
  },
  {
    name: 'island_redeem_code',
    variations: ['control', 'on'],
    isEligible: () => true,
  },
  {
    name: 'island_onboarding_birthdate_toggle',
    variations: ['control', 'on'],
    isEligible: () => true,
  },
];

export const abTests = [
  ...FEATURE_FLAGS,
  ...AB_TESTS,
];



export default abTests;
